export enum ProductTypes {
	Subscription = 'subscription',
	Product = 'product'
}
